import { useEffect, useState } from 'react';

import { LTLProfileType, getLTLProfiles } from 'lib/api/getLTLProfiles';
import { Maybe } from 'types/UtilityTypes';

export interface ProfileOption {
  value: string;
  label: string;
}

export function useLTLProfiles(
  integrationId: Maybe<number>,
  type: Maybe<LTLProfileType>
): { options: ProfileOption[]; isLoading: boolean } {
  const [options, setOptions] = useState<ProfileOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (integrationId == null || type == null) {
      setOptions([]);
      return;
    }

    let cancelled = false;
    setIsLoading(true);

    getLTLProfiles(integrationId, type, true).then((result) => {
      if (cancelled) {
        return;
      }

      setIsLoading(false);

      if (result.isOk() && result.value.profiles?.length) {
        setOptions(
          result.value.profiles.map((p) => ({
            value: p.value,
            label: p.label,
          }))
        );
      } else {
        setOptions([]);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [integrationId, type]);

  return { options, isLoading };
}
